module.exports = __webpack_public_path__ + "images/23f5eae056ad606c8868310be432e876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/cpi-mobile-logo.jpg
// module id = 1248
// module chunks = 0